import reducerRegistry from '../reducerRegistry';

const reducerName = 'affiliates';
const createActionName = name => `toi/${reducerName}/${name}`;

export const SET_SALE_NUDGE_STATUS = createActionName('SET_SALE_NUDGE_STATUS');
export const SET_ASTRO_NUDGE_STATUS = createActionName(
  'SET_ASTRO_NUDGE_STATUS',
);

export function setSaleNudgeVisibility(status) {
  return {
    type: SET_SALE_NUDGE_STATUS,
    payload: status,
  };
}

export function setAstroNudgeVisibility(status) {
  return {
    type: SET_ASTRO_NUDGE_STATUS,
    payload: status,
  };
}

export default function reducer(state = {}, action = {}) {
  const { type, payload = {} } = action;
  switch (type) {
    case SET_SALE_NUDGE_STATUS:
      return {
        ...state,
        saleNudgeVisible: payload,
      };
    case SET_ASTRO_NUDGE_STATUS:
      return {
        ...state,
        astroNudgeVisible: payload.astroNudgeVisible,
        astroNudgeDataFetehed: payload.astroNudgeDataFetehed,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
